import { Spinner, TextInput } from "@narmi/design_system";
import styles from "./AiReplyBoxTextInput.module.css";

export function AiReplyBoxTextInput({
  isLoading,
  ...props
}: React.ComponentProps<typeof TextInput> & { isLoading?: boolean }) {
  return (
    <div className={styles.AiReplyBoxTextInput}>
      <TextInput
        startContent={
          isLoading && (
            <div className={styles.spinner}>
              <Spinner size={32} color="var(--color-amethyst)" />
            </div>
          )
        }
        {...props}
      />
    </div>
  );
}
